import { useEffect, useState } from 'react';

import APIService from '../../../services/api.service';

export interface EmissionFactorGroupsState {
    groups: Record<string, string[]>;
    loading: boolean;
}

export function useEmissionFactorGroups(): EmissionFactorGroupsState {
    const [groups, setGroups] = useState<Record<string, string[]>>({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isCurrent = true;
        setLoading(true);
        APIService.getEmissionFactorGroups()
            .then((res) => {
                if (isCurrent) setGroups(res.groups);
            })
            .catch(() => {
                if (isCurrent) setGroups({});
            })
            .finally(() => {
                if (isCurrent) setLoading(false);
            });
        return () => {
            isCurrent = false;
        };
    }, []);

    return { groups, loading };
}
